module.exports = __webpack_public_path__ + "static/vileoAppGif-276e9e9c401f4e5eb52f698257d62c30.gif";